import { jab, cross, hook, uppercut, slip, roll, leadPunches, leadMoves, rearPunches, rearMoves, burnouts, randomBurnout } from './../boxing/baseMoves';
import { toBoxingCombo } from './../utils/mapping';
import { getRandomItems, getOneRandom } from './../utils/array';

// Random: the break pulls random facts from an api? Or show a random GIF? Or both?
// Random: at the end, it makes up a bunch of random stat increases? Something like the Scott Pilgrim level up visual gag?

const randomCombo = (onlyPunches = true, alternating = true) => {
  let leadSide = onlyPunches ? leadPunches : leadMoves,
      rearSide = onlyPunches ? rearPunches : rearMoves;

  if (!alternating) {
    leadSide = [...leadSide, ...rearSide];
    rearSide = leadSide;
  }

  const randomMoves = [
    getOneRandom(leadSide),
    getOneRandom(rearSide),
    getOneRandom(leadSide),
    getOneRandom(rearSide),
    getOneRandom(leadSide),
    getOneRandom(rearSide)
  ];

  return [
    [randomMoves[0], randomMoves[1]],
    [randomMoves[0], randomMoves[1], randomMoves[2]],
    [randomMoves[0], randomMoves[1], randomMoves[2], randomMoves[3]],
    [randomMoves[0], randomMoves[1], randomMoves[2], randomMoves[3], randomMoves[4]],
    [randomMoves[1], randomMoves[2], randomMoves[3], randomMoves[4], randomMoves[5]],
    randomBurnout()
  ].map(toBoxingCombo).reverse();
};

const classicCombo = () => {
  return [
    [jab()],
    [jab(), cross()],
    [jab(), cross(), hook('lead')],
    [jab(), cross(), hook('lead'), uppercut('rear')],
    [jab(), cross(), hook('lead'), uppercut('rear'), hook('lead')],
    randomBurnout()
  ].map(toBoxingCombo).reverse();
};

const jabCrossBuildCombo = () => {
  return [
    [jab(), cross()],
    [jab(), cross(), jab()],
    [jab(), cross(), jab(), cross()],
    [jab(), jab(), cross(), jab(), cross()],
    [jab(), jab(), cross(), jab(), cross(), hook('lead')],
    randomBurnout()
  ].map(toBoxingCombo).reverse();
}

const hookUppercutBuildCombo = () => {
  return [
    [uppercut('lead'), uppercut('rear')],
    [uppercut('lead'), uppercut('rear'), hook('lead')],
    [uppercut('lead'), uppercut('rear'), hook('lead'), cross()],
    [uppercut('lead'), uppercut('rear'), hook('lead'), cross(), hook('lead')],
    [uppercut('lead'), uppercut('rear'), hook('lead'), cross(), hook('lead'), uppercut('read')],
    randomBurnout()
  ].map(toBoxingCombo).reverse();
}

const jabCrossRandomCombo = () => {
  const combos = getRandomItems([
    [jab()],
    [jab(), cross()],
    [jab(), cross(), jab()],
    [jab(), cross(), jab(), cross()],
    [jab(), jab(), cross(), jab(), cross()],
    [jab(), jab(), cross()],
    [jab(), jab(), jab(), cross()],
    [jab(), jab(), cross(), jab()],
    [jab(), jab(), cross(), jab(), cross()],
  ], 5);

  return [
    ...combos,
    randomBurnout()
  ].map(toBoxingCombo).reverse();
}

const hookUppercutRandomCombo = () => {
  const combos = getRandomItems([
    [hook('rear'), uppercut('lead')],
    [hook('rear'), uppercut('lead'), uppercut('rear')],
    [hook('rear'), uppercut('lead'), uppercut('rear'), hook('lead')],
    [hook('rear'), uppercut('lead'), hook('rear'), uppercut('lead')],
    [uppercut('rear'), hook('lead')],
    [uppercut('rear'), hook('lead'), hook('rear')],
    [uppercut('rear'), hook('lead'), uppercut('rear'), hook('lead')],
    [uppercut('rear'), uppercut('lead'), hook('rear'), hook('lead')],
    [hook('rear'), hook('lead'), uppercut('rear'), uppercut('lead')]
  ], 5);

  return [
    ...combos,
    randomBurnout()
  ].map(toBoxingCombo).reverse();
}

// Pairs of non-alternating for heavier power
const powerCombo = () => {
  const combos = getRandomItems([
    [uppercut('lead'), hook('lead')],
    [hook('lead'), uppercut('lead')],
    [uppercut('rear'), hook('rear')],
    [hook('rear'), uppercut('rear')],
    [cross(), hook('rear')],
    [cross(), uppercut('rear')],
    [cross(), hook('rear'), uppercut('rear')],
    [uppercut('rear'), hook('rear'), cross()]
  ], 6);

  return combos.map(toBoxingCombo).reverse();
}

// Gap combos, like uppercut jab hook
const gapCombo = () => {
  const combos = getRandomItems([
    [uppercut('rear'), jab(), cross()],
    [jab(), cross(), uppercut('lead')],
    [uppercut('rear'), uppercut('lead'), cross()],
    [jab(), jab(), hook('rear')],
    [jab(), jab(), hook('uppercut')],
    [hook('lead'), hook('rear'), jab(), cross()]
  ], 5);

  return [
    ...combos,
    randomBurnout()
  ].map(toBoxingCombo).reverse();
}

const carewCombo = () => {
  const combos = getRandomItems([
    [jab(), cross(), hook('lead'), cross()],
    [cross(), hook('lead'), uppercut('rear'), slip('lead'), cross()],
    [uppercut('lead'), cross(), jab(), cross()],
    [cross(), roll('lead'), cross(), uppercut('lead'), cross()],
    [cross(), jab(), cross()],
    [cross(), uppercut('lead'), cross()],
    [jab(), cross(), slip('lead'), slip('rear'), roll('lead'), cross()]
  ], 4);

  return [
    [cross(), cross(), uppercut('lead'), cross()],
    ...combos,
    randomBurnout()
  ].map(toBoxingCombo).reverse();
}

const burnoutCombo = () => {
  return getRandomItems(burnouts, 6).map(toBoxingCombo);
};

export { randomCombo, classicCombo, burnoutCombo, jabCrossBuildCombo, hookUppercutBuildCombo, jabCrossRandomCombo, hookUppercutRandomCombo, powerCombo, carewCombo, gapCombo }
